module.exports = __webpack_public_path__ + "img/Cutaways_house_4_a_tile.62e0c632.jpg";